import { html } from 'lit';
import { step } from '../types.js';
export function Axis(steps: step[]) {
  return html`<div class="axis">${steps.map(({
    tick
  }) => html`<i style="opacity: ${tick ? '1.0' : '0'}"></i>`)}</div>`;
}